module.exports = __webpack_public_path__ + "img/curva-login-pico.d835fc22.png";